import { Question } from './question.model';

// Without this dynamic parameter AOT compiling will fail.
// @see https://angular.io/guide/angular-compiler-options#strictmetadataemit
// @dynamic
export class KeywordQuestion extends Question {
  public static fromDto(dto: any): KeywordQuestion {
    const question: KeywordQuestion = new KeywordQuestion();
    Question.mapBaseProperties(question, dto);
    return question;
  }
}
